<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Finish Good Quality Inspection" active>

                                <b-row v-if="hasFailedDataFinishGoodQualityInspection">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQualityInspection.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectionsFailed" :fields="fieldsFinishGoodQualityInspection" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspection" :sort-desc.sync="sortDescFinishGoodQualityInspection" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyPending)="row">
													{{ Number(row.item.qtyPending).toLocaleString() }}
												</template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQualityInspection.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspections" :fields="fieldsFinishGoodQualityInspection" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspection" :sort-desc.sync="sortDescFinishGoodQualityInspection" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyPending)="row">
													{{ Number(row.item.qtyPending).toLocaleString() }}
												</template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Finish Good Quality Inspection Ng" active>

                                <b-row v-if="hasFailedDataFinishGoodQualityInspectionNg">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQualityInspectionNg.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectionNgsFailed" :fields="fieldsFinishGoodQualityInspectionNg" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectionNg" :sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQualityInspectionNg.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectionNgs" :fields="fieldsFinishGoodQualityInspectionNg" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectionNg" :sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionList from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionList';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsFinishGoodQualityInspection: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Before", key: 'qtyBefore', sortable: false},
				{"class" : "th-status", "label" : "Qty After", key: 'qtyAfter', sortable: false},
				{"class" : "th-status", "label" : "Qty Pending", key: 'qtyPending', sortable: false},
				{"class" : "th-status", "label" : "Qty Ng", key: 'qtyNg', sortable: false},
				{"class" : "th-status", "label" : "Metode Qc", key: 'metodeQcName', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Detail", key: 'workOrderProcessDetailPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsFinishGoodQualityInspectionNg: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Problem Category", key: 'problemCategoryCode', sortable: false},
				{"class" : "th-status", "label" : "Qty Ng", key: 'qtyNg', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			finishGoodQualityInspections : [],
			finishGoodQualityInspectionsFailed: [],
			finishGoodQualityInspectionId : '',
			sortByFinishGoodQualityInspection: '',
			sortDescFinishGoodQualityInspection: '',
			hasFailedDataFinishGoodQualityInspection: false,
			totalFailedFinishGoodQualityInspection: 0,
			totalSucceedFinishGoodQualityInspection: 0,
			finishGoodQualityInspectionNgs : [],
			finishGoodQualityInspectionNgsFailed: [],
			finishGoodQualityInspectionNgId : '',
			sortByFinishGoodQualityInspectionNg: '',
			sortDescFinishGoodQualityInspectionNg: '',
			hasFailedDataFinishGoodQualityInspectionNg: false,
			totalFailedFinishGoodQualityInspectionNg: 0,
			totalSucceedFinishGoodQualityInspectionNg: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('finishgoodqualityinspection/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('finishgoodqualityinspection/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getFinishGoodQualityInspectionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getFinishGoodQualityInspectionForUpload : async function() {
			let _this = this;
			this.$http.get('finishgoodqualityinspection/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.finishGoodQualityInspections = [];
_this.finishGoodQualityInspectionNgs = [];


					if (response != null) {
						let result = response.data;
						_this.finishGoodQualityInspections = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedFinishGoodQualityInspection = _this.finishGoodQualityInspections.length;

						_this.finishGoodQualityInspectionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataFinishGoodQualityInspection = true;
						_this.totalFailedFinishGoodQualityInspection = 0;
						if(_this.finishGoodQualityInspectionsFailed == undefined || _this.finishGoodQualityInspectionsFailed.length === 0) _this.hasFailedDataFinishGoodQualityInspection = false;
						if(_this.hasFailedDataFinishGoodQualityInspection) _this.totalFailedFinishGoodQualityInspection = _this.finishGoodQualityInspectionsFailed.length;
						_this.finishGoodQualityInspectionNgs = [];
						_this.finishGoodQualityInspectionNgsFailed = [];
						_this.hasFailedDataFinishGoodQualityInspectionNg = true;
						_this.totalSucceedFinishGoodQualityInspectionNg = 0;
						result.forEach(function(element) {
							_this.finishGoodQualityInspectionNgs.push(...element.finishGoodQualityInspectionNg.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedFinishGoodQualityInspectionNg = _this.finishGoodQualityInspectionNgs.length;

							_this.finishGoodQualityInspectionNgsFailed.push(...element.finishGoodQualityInspectionNg.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.finishGoodQualityInspectionNgsFailed == undefined || _this.finishGoodQualityInspectionNgsFailed.length === 0) _this.hasFailedDataFinishGoodQualityInspectionNg = false;
							if(_this.hasFailedDataFinishGoodQualityInspectionNg) _this.totalFailedFinishGoodQualityInspectionNg = _this.finishGoodQualityInspectionNgsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'finishgoodqualityinspection/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'FinishGoodQualityInspection.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterFinishGoodQualityInspection = new FinishGoodQualityInspectionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
